import React from 'react';
import Unauthorized from '../components/CommonComponents/Unauthorized';

const UnauthorizedPage = () => {
    return (
        <div>
            <Unauthorized />
        </div>
    );
};

export default UnauthorizedPage;
